<div class="mb-33" style="height: 25px">
  <h3>{{ 'dashboard.events.title' | translate | titlecase }}</h3>
</div>
<div style="height: calc(100% - 58px)" id="dashboard-events-container">
  <wl-card>
    <div class="event-list-container mct-flex mct-col mct-justify-between mct-items-stretch">
      <div class="mct-flex mct-col" style="height: calc(100%)">
        <div *ngFor="let event of eventsList.Result; let i = index">
          <div class="event-list-body">
            <div>
              <span class="f-wb" style="font-size: 15px"
                ><a [routerLink]="['/event/' + event.EventId.toString()]">{{ event.EventName }}</a></span
              >
            </div>
            <div class="mct-flex mct-row mct-wrap mct-justify-between mct-items-stretch">
              <div>
                <span class="f-wb">{{ event.StartDateTimeUtc | date: 'M/d/yyyy' }}</span> {{ event.StartTime }}
                <span
                  [hidden]="
                    (event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy') &&
                    event.StartTime == event.EndTime
                  "
                  >-
                  <span [hidden]="(event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy')" class="f-wb">{{
                    event.EndDateTimeUtc | date: 'M/d/yyyy'
                  }}</span>
                  {{ event.EndTime }}</span
                >
              </div>
              <div class="mct-flex mct-row mct-gap-4">
                <div>
                  <span class="icon-badge" style="height: 21px; line-height: 14px">{{
                    event.TotalInvoiced | currency: 'USD' : 'symbol' : '1.0-0'
                  }}</span>
                </div>
                <div>
                  <span class="icon-badge" style="height: 21px; line-height: 14px"
                    ><i class="pi pi-user"></i>{{ event.PotentialAttendees }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <hr *ngIf="i < eventsList.Result.length - 1" />
        </div>
      </div>
    </div>
    <div style="font-weight: bold">
      <wl-paging-controls #pagingControls [pagedResult]="eventsList" (pagingEvent)="onPagingEvent($event)"></wl-paging-controls>
    </div>
    <!-- </div> -->
  </wl-card>
</div>
